import { useCallback, useMemo } from 'react';
import { applyExcelFormats, parseExcelFormats } from '../../../../utils/excel';
import { RISK_INDICATORS_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportRiskIndicators({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null
                ? applyExcelFormats(value, RISK_INDICATORS_COLUMNS[key]?.style?.numFmt)
                : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const formattedTableColumns = useMemo(
    () =>
      Object.entries(RISK_INDICATORS_COLUMNS).reduce(
        (acc, [key, value]) => (!value.hidden ? { ...acc, [key]: { ...value } } : acc),
        {},
      ),
    [],
  );

  const formatCellConditionally = useCallback(({ reportItem, tableColumnKey }) => {
    if (
      tableColumnKey.includes('_value') &&
      reportItem[tableColumnKey] !== null &&
      reportItem[tableColumnKey] !== undefined &&
      reportItem[tableColumnKey.replace('_value', '_threshold')] !== null &&
      reportItem[tableColumnKey.replace('_value', '_threshold')] !== undefined &&
      parseExcelFormats(reportItem[tableColumnKey]) >
        parseExcelFormats(reportItem[tableColumnKey.replace('_value', '_threshold')])
    ) {
      return ' bg-danger';
    }

    return '';
  }, []);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={formattedTableColumns}
        headerHeight={36}
        rowKey="consumerId"
        formatCellConditionally={formatCellConditionally}
      />
    </>
  );
}

export default ReportRiskIndicators;
